/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sbp from '@sbp/sbp'
import AvatarUser from '../../../../frontend/views/components/AvatarUser.vue'
import ProfileCard from '../../../../frontend/views/components/ProfileCard.vue'
import { OPEN_MODAL } from '../../../../frontend/utils/events.js'
import { mapGetters } from 'vuex'

const __vue_script__ = ({
  name: 'Profile',
  components: {
    AvatarUser,
    ProfileCard
  },
  computed: {
    ...mapGetters([
      'ourUsername',
      'ourIdentityContractId'
    ]),
    ourDisplayName () {
      const userContract = this.$store.getters.currentIdentityState
      return userContract && userContract.attributes && userContract.attributes.displayName
    }
  },
  methods: {
    openModalUserSettings () {
      sbp('okTurtles.events/emit', OPEN_MODAL, 'UserSettingsModal')
    }
  }
}        )

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.loggedIn)?_c('div',{staticClass:"c-profile",attrs:{"data-test":"userProfile"}},[_c('profile-card',{attrs:{"contractID":_vm.ourIdentityContractId,"direction":"top-left"}},[_c('button',{staticClass:"is-unstyled c-avatar-user",attrs:{"data-test":"openProfileCard"}},[_c('avatar-user',{attrs:{"contractID":_vm.ourIdentityContractId,"size":"sm"}}),_c('div',{staticClass:"c-user"},[_c('strong',{staticClass:"has-ellipsis",attrs:{"data-test":_vm.ourDisplayName ? "profileDisplayName" : "profileName"}},[_vm._v(_vm._s(_vm.ourDisplayName || _vm.ourUsername || _vm.ourIdentityContractId))]),(_vm.ourDisplayName)?_c('span',{staticClass:"has-ellipsis",attrs:{"data-test":"profileName"}},[_vm._v("@"+_vm._s(_vm.ourUsername))]):_vm._e()])],1)]),_c('button',{staticClass:"is-icon-small",attrs:{"data-test":"settingsBtn"},on:{"click":_vm.openModalUserSettings}},[_c('i',{staticClass:"icon-cog"})])],1):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-469c796a_0", { source: ".c-profile[data-v-469c796a]{display:flex;justify-content:space-between;align-items:center;height:4rem;padding:0 1rem}.c-avatar-user[data-v-469c796a]{display:flex;align-items:center}.c-avatar-user:focus .c-user strong[data-v-469c796a],.c-avatar-user:hover .c-user strong[data-v-469c796a]{border-bottom-color:var(--text_0)}.c-user[data-v-469c796a]{display:flex;flex-direction:column;align-items:flex-start;margin-left:.5rem;max-width:7rem;white-space:nowrap;line-height:1.3;margin-top:1px}.c-user strong[data-v-469c796a]{border-bottom:1px solid transparent;width:100%}.c-user span[data-v-469c796a]{font-family:Lato;color:var(--text_1);width:100%}button .icon-cog[data-v-469c796a]{font-size:.875rem;transform-origin:49% 48%}button:focus .icon-cog[data-v-469c796a],button:hover .icon-cog[data-v-469c796a]{animation:cog-data-v-469c796a .4s forwards}@keyframes cog-data-v-469c796a{to{transform:rotate(180deg)}}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-469c796a"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__